<template>
  <div class="settingPage">
    <div class="flexBox">
      <div class="flexInner">
        <div class="innerItem">
          <p class="innerTitle setLabel toCapitalize">{{locale.title_staytalk}}</p>
          <div class="siteTitle translation">
            <input type="text" class="input" v-model="setting.title[lang.default]" @focusout="setDefaultVal('title')">
            <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click="onLangValueOpen('title')">
              <span class="blind">{{locale.language_specific_set}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
            </button>
          </div>
        </div>
        <div class="innerItem">
          <p class="innerTitle setLabel toCapitalize">{{locale.talk_setting_enterance}}</p>
          <button type="button" class="btn btnWhite toCapitalize" @click="setEdit('enterance', true, 'talk_setting_enterance')">{{locale.setting}}</button>
        </div>
        <div class="innerItem">
          <p class="innerTitle setLabel toCapitalize">{{locale.talk_setting_welcome}}</p>
          <button type="button" class="btn btnWhite toCapitalize" @click="setEdit('welcome', true, 'talk_setting_welcome')">{{locale.setting}}</button>
        </div>
        <div class="innerItem">
          <p class="innerTitle setLabel toCapitalize">{{locale.talk_setting_disabled}}</p>
          <button type="button" class="btn btnWhite toCapitalize" @click="setEdit('missed', true, 'talk_setting_disabled')">{{locale.setting}}</button>
        </div>
      </div>
      <div class="flexInner">
        <div class="innerItem">
          <p class="innerTitle setLabel">{{locale.translate_auto}}</p>
          <div class="checkbox">
            <input type="checkbox" id="disabled_translate" v-model="setting.disabledTranslate">
            <label for="disabled_translate">{{locale.disabled}}</label>
          </div>
        </div>
        <div class="innerItem">
          <p class="innerTitle setLabel">UI</p>
          <div class="checkbox mb10">
            <input type="checkbox" id="view_available_time" v-model="setting.viewAvailableTime">
            <label for="view_available_time">{{locale.talk_setting_display_available}}</label>
          </div>
          <p class="sysMessage">{{locale.message_setting_display_available}}</p>
        </div>
        <div class="innerItem">
          <p class="innerTitle setLabel toCapitalize">{{locale.talk_setting_profile_thumb}}</p>
          <div class="mb15">
            <div class="checkbox radio mr15">
              <input type="radio" name="sender_icon" id="sender_icon_0" v-model="setting.senderIcon" value="0">
              <label for="sender_icon_0">
                <span class="userThumb"><img src="~@/assets/img/ico_talk_user.png" alt="" /></span>
              </label>
            </div>
            <div class="checkbox radio mr15">
              <input type="radio" name="sender_icon" id="sender_icon_1" v-model="setting.senderIcon" value="1">
              <label for="sender_icon_1">
                <span class="userThumb"><img src="~@/assets/img/ico_talk_user_1.png" alt="" /></span>
              </label>
            </div>
            <div class="checkbox radio mr15">
              <input type="radio" name="sender_icon" id="sender_icon_2" v-model="setting.senderIcon" value="2">
              <label for="sender_icon_2">
                <span class="userThumb"><img src="~@/assets/img/ico_talk_user_2.png" alt="" /></span>
              </label>
            </div>
          </div>
          <div>
            <div class="checkbox radio mt10">
              <input type="radio" name="sender_icon" id="sender_icon_upload" v-model="setting.senderIcon" value="3">
              <label for="sender_icon_upload">{{locale.direct_input}}</label>
            </div>
            <div v-if="setting.senderIcon === '3'" class="mt10">
              <span v-if="setting.senderIconThumb && setting.senderIconThumb !== ''" class="userThumb custom mr15">
                <img :src="setting.senderIconThumb" alt="">
              </span>
              <label class="btn btnWhite sizeS"
                for="upload_sender_icon">
                <input type="file"
                  id="upload_sender_icon"
                  @change="uploadImage($event)">
                {{locale.upload}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- 화면관리 -->
      <Edit
        v-if="activeItem"
        :locale="locale"
        :lang="lang"
        :activeTarget="activeTarget"
        :activeItem="activeItem"
        :settingTitle="settingTitle"
        :cardList="cardList"
        :tagList="tagList"
        @apply="apply"
        @cancel="setEdit(activeItem, false)" />
      <!-- //화면 관리 -->
      <!-- 언어별 세팅 -->
      <LangValue v-show="langValueLayer"
        :locale="locale"
        :textarea="textarea"
        :langValue="langValue"
        :title="locale.language_specific_set"
        @close="onLangValueClose(langValueTarget)" />
      <!-- //언어별 세팅 -->
    </div>
  </div>
</template>

<script>
import LangValue from '@/components/Util/LangValue.vue'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import Edit from '@/components/Talk/SettingEdit'

export default {
  name: 'Setting',
  props: [
    'locale',
    'lang',
    'setting',
    'cardList',
    'tagList'
  ],
  components: {
    LangValue,
    Edit
  },
  data () {
    return {
      textarea: false,
      langValueTarget: '',
      langValueLayer: false,
      langValue: {},
      activeTarget: null,
      activeItem: null,
      settingTitle: ''
    }
  },
  methods: {
    setDefaultVal (target) {
      const defaultLang = this.lang.default
      const fillLangs = UTIL.fillLangs(this.setting[target], this.setting[target][defaultLang])
      this.setting[target] = fillLangs
    },
    onLangValueOpen (target) {
      this.langValueLayer = true
      this.langValueTarget = target
      this.langValue = this.setting[target]
      this.setDefaultVal(target)
    },
    onLangValueClose (target) {
      this.langValueLayer = false
      this.setting[target] = this.langValue
      this.langValue = {}
    },
    setEdit (target, isActive, title) {
      this.activeTarget = isActive ? target : null
      this.activeItem = isActive
        ? this.setting[target]
        : null
      this.settingTitle = title
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          // this.$store.commit('tv/updateChLogo', { id: productId, logo: res.source })
          this.setting.senderIconThumb = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    apply (data) {
      this.$emit('apply', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.userThumb {
  display: inline-block;
  width: 50px;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  border: 1px solid $color-lgrey2;
  border-radius: 16px;
  background-color: $color-white;
  img {
    width: 34px;
    margin: 7px;
  }
  &.custom {
    img {
      width: 100%;
      height: 100%;
      margin: auto;
      object-fit: contain;
      overflow: hidden;
    }
  }
}
</style>
